exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "  .seg-1 {\n    fill: #1e4e69;\n  }\n\n  .seg-2 {\n    fill: none;\n  }\n\n  .seg-3 {\n    fill: #ee7470;\n    opacity: 0.331;\n  }\n\n  .seg-3, .seg-4 {\n    isolation: isolate;\n  }\n\n  .seg-4 {\n    fill: #72cac2;\n    opacity: 0.375;\n  }", ""]);
